<template>
    <div id="remark">
        <headers :title='titles'></headers>
        <div v-if="!loadingS">
            <div class="stu">
                <div class="clearfix"
                     v-for="item in list">
                    <span class="stu_left"
                          v-if="type==1">已完成（<span class="yellow">{{item.user_id.length}}人</span>）</span>
                    <span class="stu_left"
                          v-else>{{item.name}}（<span class="yellow">{{item.user_id.length}}人</span>）</span>
                    <span class="stu_right"
                          v-if="type==1">奖励：50钻石/人</span>
                    <span class="stu_right"
                          v-else>奖励：{{item.diamonds}}钻石/人</span>
                </div>
            </div>
            <div class="remark">
                <div class="clearfix">
                    <p>评语：</p>
                    <p class="template"
                       @click="chooseRemark">评语模板</p>
                </div>
                <textarea class="text"
                          name="text"
                          @input="descInput"
                          v-model="desc"
                          maxlength="100"></textarea>
                <p class="tips">还可以输入{{txtVal}}字</p>
            </div>
            <div class="list"
                 v-if="remarkShow">
                <div class="bottom">
                    <div class="top">
                        <p><i></i>选择模板</p>
                        <i class="close"
                           @click="close"></i>
                    </div>
                    <p @click="choose(text)"
                       v-for="text in remark"
                       class="word">{{text}}</p>
                </div>
            </div>
            <div class="bottom_btn">
                <div @click="send">立即发送</div>
            </div>
        </div>
        <div v-else>
            <loading></loading>
        </div>
    </div>
</template>

<script type="text/ecmascript-6">
import headers from 'SRC/components/base/header.vue';
import loading from 'COMPONENTS/base/tealoading.vue';
export default {
    data () {
        return {
            titles: '发奖励写评语',
            txtVal: 100,
            desc: "完成的很不错，继续加油！",
            remark: ['做的太棒了！', '你的作业完成质量比以前有了很大提高！', '你是一个很有潜力的学生！', '做题要专注，不要粗心大意！', '一定要仔细审题，留心观察和思考！', '多思考前后知识的联系，你会有更大提高！'],
            remarkShow: false,
            sendstatus: true,//防止连点
            sid: this.$route.params.sid,
            testId: this.$route.params.testId,
            classId: this.$route.params.classId,
            list: [],
            type: this.$route.query.remark ? this.$route.query.remark : 0,//语文生词听写，数学视频作业后端无法判断，显示已完成人数
            loadingS: true,
            timer: null,
        }
    },
    components: {
        loading,
        headers
    },
    created () {
        this.txtVal = 100 - Number(this.desc.length);
        this.$http.post(API_URL_TASK_API + '/public/task/tea/reword/comment', { 'message_id': this.testId, 'unit_class_id': this.classId, 'sid': this.sid }).then(res => {
            this.loadingS = false;
            if (res.data.response == 'ok') {
                this.list = res.data.data.students;
            }
            // //console.log(this.list,res.data.data)
        })
    },
    methods: {
        descInput () {
            this.desc = this.desc.substring(0, 100);
            this.txtVal = 100 - this.desc.length;
        },
        chooseRemark () {
            this.remarkShow = true;
        },
        choose (word) {
            this.desc = word;
            this.descInput();
            this.close();
        },
        close () {
            this.remarkShow = false;
        },
        send () {
            if (!this.sendstatus) {
                return false;
            }
            if (this.desc.replace(/\s+/g, "") == '') {
                layer.tips('请先输入评语');
            } else {
                this.sendstatus = false;
                let obj = {
                    message_id: this.testId,
                    unit_class_id: this.classId,
                    sid: this.sid,
                    detail: this.list,
                    content: this.desc
                }
                this.$http.post(API_URL_TASK_API + '/public/task/tea/reword/diamonds', obj).then(res => {
                    this.sendstatus = true;
                    if (res.data.response == 'ok') {
                        layer.tips('奖评发送成功');
                        let _this = this;
                        this.timer && clearTimeout(this.timer);
                        this.timer = setTimeout(function () {
                            _this.$router.go(-1);
                        }, 1200)
                    } else {
                        // this.sendstatus = true;
                        layer.tips('发送失败，请稍后再试');
                    }
                })
            }
        }
    },
    beforeDestroy () {
        layer.closeAll();
        clearTimeout(this.timer);
    }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
@import "./src/assets/scss/common/_mixin";
#remark {
    position: relative;
    min-height: 100vh;
}
.stu {
    width: 100%;
    background: #fff;
    margin-bottom: 25px / $ppr;
    div {
        padding: 0 25px / $ppr;
        height: 96px / $ppr;
        border-top: 1px / $ppr solid #e8e8e8;
        line-height: 96px / $ppr;
        .stu_left {
            font-size: 30px / $ppr;
            color: #333;
        }
        .stu_right {
            font-size: 24px / $ppr;
            color: #999;
            float: right;
        }
    }
}
.yellow {
    color: #ff6600;
}
.remark {
    // width:670px/$ppr;
    background: #fff;
    // margin:0 auto;
    padding: 0 25px / $ppr 25px / $ppr;
    div {
        padding: 20px / $ppr 0;
        p {
            color: #999;
            font-size: 30px / $ppr;
            float: left;
            height: 48px / $ppr;
            line-height: 48px / $ppr;
            width: 100px / $ppr;
        }
        .template {
            float: right;
            width: 125px / $ppr;
            border: 1px solid #5e89ef;
            font-size: 24px / $ppr;
            text-align: center;
            color: #5e89ef;
            border-radius: 8px / $ppr;
        }
    }
    .tips {
        text-align: right;
        line-height: 70px / $ppr;
        color: #999;
    }
}
.text {
    display: block;
    width: 610px / $ppr;
    padding: 25px / $ppr;
    margin: 0 auto;
    height: 210px / $ppr;
    background: #f6f6f6;
    border: none;
}
.bottom_btn {
    height: 96px / $ppr;
    width: 100%;
    margin-top: 25px / $ppr;
    div {
        position: absolute;
        bottom: 0;
        right: 0;
        left: 0;
        background: #5e89ef;
        text-align: center;
        font-size: 30px / $ppr;
        color: #fff;
        line-height: 96px / $ppr;
    }
}
.list {
    width: 100%;
    height: 100vh;
    background: rgba(0, 0, 0, 0.6);
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 9;
    .bottom {
        width: 100%;
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        z-index: 10;
        font-size: 30px / $ppr;
        animation: myfirst 0.3s;
        -webkit-animation: myfirst 0.3s;
        animation-fill-mode: forwards; /*当动画完成时，动画会停留在最后一帧。*/
        .top {
            background: #f6f6f6;
            height: 96px / $ppr;
            padding: 0 25px / $ppr;
            line-height: 96px / $ppr;
            border-top-left-radius: 20px / $ppr;
            border-top-right-radius: 20px / $ppr;
            color: #999;
            position: relative;
            p {
                padding-left: 45px / $ppr;
                i {
                    position: absolute;
                    left: 25px / $ppr;
                    top: 26px / $ppr;
                    display: block;
                    width: 40px / $ppr;
                    height: 44px / $ppr;
                    background: url("./img/remark.png") 0 0 no-repeat;
                    background-size: 100% 100%;
                }
            }
            .close {
                position: absolute;
                top: 32px / $ppr;
                right: 25px / $ppr;
                width: 32px / $ppr;
                height: 32px / $ppr;
                background: url("./img/remark_close.png") 0 0 no-repeat;
                background-size: 100% 100%;
            }
        }
        .word {
            background: #fff;
            padding: 0 25px / $ppr;
            border-top: 1px / $ppr solid #e8e8e8;
            line-height: 98px / $ppr;
            color: #333;
        }
    }
    @-webkit-keyframes myfirst {
        0% {
            height: 0;
            bottom: 0;
        }
        100% {
            height: 687px / $ppr;
            bottom: 0;
        }
    }
}
</style>
